import { ArrowUp, MapPin, Mail } from "lucide-react";
import { assets } from "../lib/assets";

export default function Footer({ t }) {
  const year = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-emerald-950 text-emerald-50 border-t border-emerald-900/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="flex flex-col lg:flex-row items-start justify-between gap-8">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6">
            <div className="flex items-center gap-3">
              <img src={assets.logo} alt="Shandong Prit Biotechnology" className="h-8 w-auto max-w-[120px] object-contain brightness-0 invert opacity-90" />
              <div>
                <span className="font-heading font-semibold text-sm tracking-tight text-brand-blue-light">SHANDONG PRIT</span>
                <span className="text-emerald-400/50 text-sm mx-2">|</span>
                <span className="text-emerald-200/80 text-sm">{t.footer.tagline}</span>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-6 text-sm">
              <div className="flex items-start gap-2">
                <MapPin className="w-4 h-4 shrink-0 mt-0.5 text-emerald-400/70" />
                <div>
                  <p className="text-emerald-400/70 text-xs uppercase tracking-wider mb-0.5">{t.footer.address}</p>
                  <a
                    href={`https://maps.google.com/?q=${encodeURIComponent(t.contact.addressValue)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-emerald-200/90 hover:text-emerald-50 transition-colors"
                  >
                    {t.contact.addressValue}
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <Mail className="w-4 h-4 shrink-0 mt-0.5 text-emerald-400/70" />
                <div>
                  <p className="text-emerald-400/70 text-xs uppercase tracking-wider mb-0.5">{t.footer.email}</p>
                  <a
                    href={`mailto:${t.contact.emailValue}`}
                    className="text-emerald-200/90 hover:text-emerald-50 transition-colors"
                  >
                    {t.contact.emailValue}
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-4 shrink-0">
            <span className="text-emerald-200/70 text-sm">&copy; {year} {t.footer.copyright}</span>
            <button
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              data-testid="scroll-to-top"
              className="w-8 h-8 rounded-lg bg-brand-blue-light/20 border border-brand-blue-light/30 flex items-center justify-center hover:bg-brand-blue-light/30 transition-all duration-300 hover:scale-110"
            >
              <ArrowUp className="w-3.5 h-3.5 text-brand-blue-light" />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
